var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _rect3, _path9, _path0, _rect4, _rect5, _rect6, _polyline, _path1, _path10, _polyline2, _line, _polyline3, _polyline4, _line2, _line3, _line4, _line5, _line6, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#2f3e4a;}.cls-1,.cls-2{stroke-width:.25px;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-1,.cls-4{fill:#2f3e4a;}.cls-5{fill:#f2b337;}.cls-2{fill:#231f20;}.cls-2,.cls-3{stroke:#231f20;}.cls-3{fill:none;stroke-width:.75px;}.cls-6{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.16,46c0-23.29-18.88-42.16-42.16-42.16S3.84,22.71,3.84,46s18.87,42.16,42.16,42.16,42.16-18.88,42.16-42.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46,4.22C22.96,4.22,4.22,22.96,4.22,46s18.74,41.78,41.78,41.78,41.78-18.74,41.78-41.78S69.04,4.22,46,4.22M46,88.55c-23.46,0-42.54-19.09-42.54-42.54S22.54,3.45,46,3.45s42.54,19.09,42.54,42.55-19.09,42.54-42.54,42.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.37,64.87v-20.93h3.92v4.07c-1.17,1.52-1.86,3.41-1.86,5.47s.69,3.97,1.86,5.48v5.91h-3.92Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 40.49,
    y: 50.48,
    width: 3.91,
    height: 14.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 33.59,
    y: 55.71,
    width: 3.92,
    height: 9.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.99,33.12c0-1.35.67-2.54,1.7-3.27.66-.48,1.46-.75,2.32-.75,2.23,0,4.03,1.8,4.03,4.02,0,1.27-.58,2.42-1.52,3.15-.68.55-1.56.88-2.51.88-1.56,0-2.93-.9-3.59-2.21-.27-.55-.42-1.17-.42-1.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.04,33.12c0-2.22-1.8-4.02-4.03-4.02v-5.65c5.36,0,9.69,4.33,9.69,9.67,0,3.06-1.43,5.8-3.65,7.57l-3.53-4.42c.93-.73,1.52-1.88,1.52-3.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.36,37.48l5.06-2.53c.67,1.3,2.04,2.21,3.59,2.21.95,0,1.83-.33,2.51-.88l3.53,4.42c-1.65,1.33-3.76,2.12-6.04,2.12-3.78,0-7.05-2.17-8.65-5.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.41,25.24c1.58-1.12,3.52-1.78,5.6-1.78v5.65c-.86,0-1.66.28-2.32.75l-3.28-4.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.41,34.95l-5.06,2.53c-.66-1.31-1.02-2.79-1.02-4.36,0-3.24,1.6-6.12,4.06-7.89h.01l3.28,4.62c-1.03.72-1.7,1.92-1.7,3.27,0,.66.16,1.27.42,1.82Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 26.69,
    y: 60.94,
    width: 3.93,
    height: 3.93
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.4,50.48h-3.91v14.39h3.91v-14.39ZM37.52,55.71h-3.92v9.16h3.92v-9.16ZM62.82,68.15H24.36V19.55h38.46v26.05c-1.29-.72-2.78-1.13-4.37-1.13-2.93,0-5.51,1.39-7.16,3.54v-4.07h-3.92v20.93h3.92v-5.91c1.64,2.15,4.24,3.53,7.16,3.53,1.58,0,3.08-.41,4.37-1.13v6.79ZM30.62,60.94h-3.93v3.93h3.93v-3.93ZM28.36,37.48c1.6,3.16,4.88,5.33,8.65,5.33,2.28,0,4.39-.8,6.04-2.12,2.22-1.77,3.65-4.51,3.65-7.57,0-5.34-4.34-9.67-9.69-9.67-2.08,0-4.02.66-5.6,1.78h-.01c-2.46,1.77-4.06,4.64-4.06,7.89,0,1.57.36,3.04,1.02,4.36Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.82,44.99v-25.44H24.36v48.6h38.46v-5.71"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.69,
    y: 60.94,
    width: 3.93,
    height: 3.93
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.59,
    y: 55.71,
    width: 3.92,
    height: 9.16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.49,
    y: 50.48,
    width: 3.91,
    height: 14.39
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "51.29 58.97 51.29 64.87 47.37 64.87 47.37 43.94 51.29 43.94 51.29 48.01"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.4,25.24c-2.46,1.77-4.06,4.64-4.06,7.89,0,1.57.36,3.04,1.02,4.36,1.6,3.16,4.88,5.33,8.65,5.33,2.28,0,4.39-.8,6.04-2.12,2.22-1.77,3.65-4.51,3.65-7.57,0-5.34-4.34-9.67-9.69-9.67-2.08,0-4.02.66-5.6,1.78"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.52,36.27c-.68.55-1.56.88-2.51.88-1.56,0-2.93-.9-3.59-2.21-.27-.55-.42-1.17-.42-1.82,0-1.35.67-2.54,1.7-3.27.66-.48,1.46-.75,2.32-.75,2.23,0,4.03,1.8,4.03,4.02,0,1.27-.58,2.42-1.52,3.15Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "37.01 29.11 37.01 23.45 37.01 23.44"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.41,
    y1: 34.95,
    x2: 28.36,
    y2: 37.48
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "39.52 36.27 43.05 40.7 43.05 40.71"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "34.69 29.86 31.41 25.24 31.4 25.24"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.26,
    y1: 25.07,
    x2: 59.52,
    y2: 25.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.26,
    y1: 30.43,
    x2: 59.52,
    y2: 30.43
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.26,
    y1: 35.8,
    x2: 59.52,
    y2: 35.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.55,
    y1: 46.86,
    x2: 36.8,
    y2: 46.86
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.55,
    y1: 50.96,
    x2: 36.8,
    y2: 50.96
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.41,46.91c-3.73-3.73-9.78-3.73-13.51,0s-3.73,9.78,0,13.51,9.78,3.73,13.51,0c3.73-3.73,3.73-9.78,0-13.51"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.04,47.04c-3.65,3.65-3.65,9.6,0,13.25s9.6,3.65,13.25,0c3.65-3.65,3.65-9.6,0-13.25s-9.6-3.65-13.25,0M65.54,60.55c-3.79,3.79-9.97,3.79-13.76,0s-3.79-9.97,0-13.76,9.97-3.79,13.76,0,3.79,9.97,0,13.76"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.99,48.34c-2.94-2.94-7.71-2.94-10.66,0s-2.94,7.71,0,10.66,7.71,2.94,10.66,0,2.94-7.71,0-10.66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.46,48.46c-2.87,2.87-2.87,7.53,0,10.4s7.53,2.87,10.4,0,2.87-7.53,0-10.4-7.53-2.87-10.4,0M64.12,59.12c-3.01,3.01-7.9,3.01-10.91,0s-3.01-7.9,0-10.91,7.9-3.01,10.91,0,3.01,7.9,0,10.91"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.87,62.87c-.07.07-.18.07-.26,0l-2.33-2.33c-.07-.07-.07-.18,0-.26s.18-.07.26,0l2.33,2.33c.07.07.07.18,0,.26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.72,67.4c.64.64.64,1.68,0,2.33s-1.68.64-2.33,0l-4.65-4.65c-.64-.64-.64-1.68,0-2.33s1.68-.64,2.33,0l4.65,4.65Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.87,62.87c-.57.57-.57,1.5,0,2.07l4.65,4.65c.57.57,1.5.57,2.07,0s.57-1.5,0-2.07l-4.65-4.65c-.57-.57-1.5-.57-2.07,0M74.85,69.85c-.71.71-1.87.71-2.58,0l-4.65-4.65c-.71-.71-.71-1.87,0-2.58s1.87-.71,2.58,0l4.65,4.65c.71.71.71,1.87,0,2.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditReports);
export default __webpack_public_path__ + "static/media/audit-reports.218220b434b6d5663715e46c1c98ab40.svg";
export { ForwardRef as ReactComponent };